import { BusEvent } from '@web/common';

export class AdminBrandCreatedBusEvent extends BusEvent {}
